import PropTypes from 'prop-types';
import cutDown from 'core/utils/cut-down';
import Link from 'core/components/Link';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import textStyles from '../index.styl';

export default function ReleaseTitle(props) {
  const {
    url,
    name,
    parentProps,
  } = props;

  const {
    theme: {
      controls: {
        smartTeaser: {
          carRelease: carReleaseAtoms,
        },
      },
    },
    theme,
    isMobile,
  } = parentProps;

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .titleLink
          font ${carReleaseAtoms.title.font}
          color ${carReleaseAtoms.title.color}
          text-decoration none
          transition none
          &:visited
            color ${theme.colors.primary}
            text-decoration none
          &:hover
            color ${theme.colors.primary}
            text-decoration underline
          &:active
            color ${theme.colors.primary}
            text-decoration underline

          :global(.${textStyles.image}:hover + .${textStyles.headline}) &
            text-decoration underline
      `}</style>
    </scope>
  );

  return (
    <>
      <Link
        to={url}
        className={scoped.wrapClassNames('titleLink')}
        followExternal
      >
        {cutDown(name, isMobile ? 36 : 66)}
      </Link>
      <scoped.styles />
    </>
  );
}

ReleaseTitle.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string,
  parentProps: PropTypes.object,
};
